const $$splitComponentImporter = () => import('/home/runner/work/nexus/nexus/apps/frontend/src/routes/(app)/org/$org/settings/currency/route.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute, redirect } from '@tanstack/react-router';
import { requirePermission } from '@/common/hooks/usePermissions';
import i18n from '@/common/translations/i18n';
export const Route = createFileRoute('/(app)/org/$org/settings/currency')({
  component: lazyRouteComponent($$splitComponentImporter, 'component'),
  beforeLoad: async ctx => {
    await requirePermission('edit_organization')(ctx);
    if (!ctx.context.flags.financeModuleEnabled) {
      throw redirect({
        to: '/org/$org/settings',
        params: {
          org: ctx.params.org
        }
      });
    }
  },
  loader: (): LoaderData => ({
    crumb: i18n.t($ => $.common.settings.currency.label)
  })
});